<template lang="pug">
#cs-root
  .d-flex.w-100.h-100
    transition(name='sidenav-transition' mode='out-in')
      SideNav(
        v-if='currentRoute && currentRoute.name !== HOME_ROUTE_NAME'
        :rootPath='ROOT_PATH'
        :navItems='NAV_ITEMS'
        :currentRoute='currentRoute'
      )
    transition(name='router-transition' mode='out-in')
      router-view.main-router

</template>

<script>
/* eslint-disable no-console, global-require */
import SideNav from '@/components/SideNav.vue';

const ROOT_PATH = '/approver';
const HOME_ROUTE_NAME = 'approver.home';

export default {
  components: {
    SideNav,
  },
  data: () => ({
    currentRoute: null,

    ROOT_PATH,
    HOME_ROUTE_NAME,
    NAV_ITEMS: [
      {
        title: 'รายการ<br>รออนุมัติ',
        iconSrc: require('@/assets/sidenav/admin/sidenav-item-pending-approval.svg'),
        to: `${ROOT_PATH}/pending-approval`,
      },
      {
        title: 'ตั้งราคาสินค้าและค่าคอม',
        iconSrc: require('@/assets/sidenav/admin/sidenav-item-price-settings.svg'),
        to: `${ROOT_PATH}/price-settings`,
      },
      {
        title: 'เซลล์และเป้า',
        iconSrc: require('@/assets/sidenav/admin/sidenav-item-seller-records.svg'),
        to: `${ROOT_PATH}/seller-records`,
      },
      {
        title: 'พิมพ์รายงาน',
        iconSrc: require('@/assets/sidenav/cs/sidenav-item-print.svg'),
        to: `${ROOT_PATH}/print`,
      },
      {
        title: 'ตั้งค่าส่วนตัว',
        iconSrc: require('@/assets/sidenav/admin/sidenav-item-settings.svg'),
        to: `${ROOT_PATH}/settings`,
      },
    ],
  }),
  mounted() {
    this.currentRoute = this.$route;
  },
  watch: {
    $route(to) {
      // console.log(to);
      this.currentRoute = to;
      console.log(this.currentRoute.name);
    },
  },
};
</script>

<style lang="scss">
#cs-root {
  width: 100vw;
  height: 100vh;

  .main-router {
    // overflow: scroll;
    width: calc(100vw - #{$sidenav-width});
    flex: 1;
  }
}
</style>
